var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDstoreNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5652,
    cy: 10.7797,
    r: 10.2116,
    fill: "#28946E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47556 7.84387L8.17407 9.37341L8.17541 9.37253V7.6238V6.31214L5.47556 7.84255V7.84387Z",
    fill: "#F0FFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5641 16.5238L12.9685 15.1606V15.162L15.6684 13.632V7.84263L12.9847 6.32145V6.31221L12.9766 6.31661L12.9685 6.31221V6.32145L10.5803 7.67537L8.53049 6.51336V9.5742L10.5803 10.7358L12.9712 9.38053V12.1002L12.9699 12.1011L12.9685 12.1002L10.5641 13.4634L8.17541 12.1095V12.1016L8.17272 12.1002V9.77579L5.47555 8.24669L5.47555 13.6214L5.45941 13.6307L10.5641 16.5238Z",
    fill: "#F0FFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDstoreNotification);
export default __webpack_public_path__ + "static/media/dstore-notification.b0f12785d8be4a48be8d38e0eaea8b23.svg";
export { ForwardRef as ReactComponent };